// テーマ全体スタイルのエントリポイント
// Vite が SCSS を自動コンパイルし、assets/css/theme.css に出力する
import './css/style.scss';

// Splide.js（Products & Solutions のフェードスライダー用）
import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/splide-core.min.css';

// TOP モーフ演出（img03 を 三角→円→角丸 へ flubber モーフ）
import { initWaterStage } from './water-stage.js';

document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '[data-splide-products]' ).forEach( ( el ) => {
		new Splide( el, {
			type:       'fade',
			rewind:     true,
			autoplay:   true,
			interval:   4000,
			speed:      800,
			arrows:     false,
			pagination: false,
			pauseOnHover: false,
		} ).mount();
	} );
} );

// =============================================================
// トップ FV 動画 (.p-home__mv)
// - muted 自動再生。再生終了で .is-ended を付与 → リプレイ / お問い合わせを表示。
//   ループしないため動画は最終フレームで自然に停止する。
// - リプレイで先頭から再生し直し（.is-ended を外す）。
// - 自動再生がブロックされた場合は終了状態にして、リプレイから開始できるようにする。
// =============================================================
const mvSection = document.querySelector( '[data-mv]' );
if ( mvSection ) {
	const mvVideo = mvSection.querySelector( '[data-mv-video]' );
	const mvReplay = mvSection.querySelector( '[data-mv-replay]' );

	if ( mvVideo ) {
		// ビューポートに応じて PC / SP の動画ソースを選択（不要な方をダウンロードしない）
		const isSp = window.matchMedia( '(max-width: 768px)' ).matches;
		const chosenSrc = isSp ? mvVideo.dataset.srcSp : mvVideo.dataset.srcPc;
		if ( chosenSrc ) {
			mvVideo.src = chosenSrc;
		}

		const playMv = () => {
			const p = mvVideo.play();
			if ( p && typeof p.catch === 'function' ) {
				p.catch( () => mvSection.classList.add( 'is-ended' ) );
			}
		};

		mvVideo.addEventListener( 'ended', () => {
			mvSection.classList.add( 'is-ended' );
		} );

		mvReplay && mvReplay.addEventListener( 'click', () => {
			mvSection.classList.remove( 'is-ended' );
			mvVideo.currentTime = 0;
			playMv();
		} );

		playMv();
	}
}

// トップで「ヘッダー出現」と「ページトップボタン表示」を同じタイミングで切り替えるための共通閾値（px）
const TOP_SCROLL_THRESHOLD = 200;

// =============================================================
// トップ: ヘッダーは初期非表示（PC/SP とも）。
// ページトップボタンと同じ scrollY > TOP_SCROLL_THRESHOLD で is-solid を付与し、出現させる。
// =============================================================
const homeHeader = document.querySelector( '.o-globalHeader' );
const homeMv = document.querySelector( '.p-home__mv' );
if ( homeHeader && homeMv ) {
	const updateHeaderReveal = () => {
		homeHeader.classList.toggle( 'is-solid', window.scrollY > TOP_SCROLL_THRESHOLD );
	};
	updateHeaderReveal();
	window.addEventListener( 'scroll', updateHeaderReveal, { passive: true } );
}

// =============================================================
// トップ Movie セクション (.p-home__movieFigure)
// ▶ ボタンクリックで再生開始 → is-playing を付与して ▶ を隠し、ネイティブ
// コントロールを表示（一時停止/シーク可能に）。
// =============================================================
const movieFigure = document.querySelector( '[data-movie]' );
if ( movieFigure ) {
	const movieVideo = movieFigure.querySelector( '[data-movie-video]' );
	const moviePlay = movieFigure.querySelector( '[data-movie-play]' );

	if ( movieVideo && moviePlay ) {
		moviePlay.addEventListener( 'click', () => {
			movieFigure.classList.add( 'is-playing' );
			movieVideo.controls = true;
			movieVideo.play();
		} );
	}
}

// =============================================================
// グローバルヘッダー: ドロワー / 検索モーダルの開閉
//
// - ドロワー: トップシート方式（上から降りる）、is-open クラスでトグル
//             pointer events による上スワイプで閉じる
// - 検索モーダル: hidden 属性でトグル
// =============================================================

const drawer = document.getElementById( 'globalDrawer' );
const drawerBackdrop = document.querySelector( '.o-globalDrawer__backdrop' );
const drawerToggle = document.querySelector( '[data-action="drawer-toggle"]' );
const searchModal = document.getElementById( 'globalSearch' );
const searchToggle = document.querySelector( '[data-action="search-toggle"]' );

// --- 開閉ヘルパー ---
const openDrawer = () => {
	if ( ! drawer ) return;
	drawer.classList.add( 'is-open' );
	drawer.setAttribute( 'aria-hidden', 'false' );
	drawerBackdrop && drawerBackdrop.classList.add( 'is-open' );
	drawerToggle && drawerToggle.setAttribute( 'aria-expanded', 'true' );
	document.body.classList.add( 'is-modal-open' );
};

const closeDrawer = () => {
	if ( ! drawer ) return;
	drawer.classList.remove( 'is-open' );
	drawer.setAttribute( 'aria-hidden', 'true' );
	drawer.style.transform = '';
	drawerBackdrop && drawerBackdrop.classList.remove( 'is-open' );
	drawerToggle && drawerToggle.setAttribute( 'aria-expanded', 'false' );
	document.body.classList.remove( 'is-modal-open' );
};

const toggleDrawer = () => {
	if ( drawer && drawer.classList.contains( 'is-open' ) ) {
		closeDrawer();
	} else {
		openDrawer();
	}
};

// 検索ドロップダウン: ヘッダー直下から降りるトップシート方式。is-open でトグル。
// 全画面版と違いページスクロールはロックしない（is-modal-open を付けない）。
const openSearch = () => {
	if ( ! searchModal ) return;
	closeDrawer();
	searchModal.classList.add( 'is-open' );
	searchModal.setAttribute( 'aria-hidden', 'false' );
	searchToggle && searchToggle.setAttribute( 'aria-expanded', 'true' );
};

const closeSearch = () => {
	if ( ! searchModal ) return;
	searchModal.classList.remove( 'is-open' );
	searchModal.setAttribute( 'aria-hidden', 'true' );
	searchToggle && searchToggle.setAttribute( 'aria-expanded', 'false' );
};

// ページトップボタン専用の即時クローズ。スクロールが window.scrollTo の即時ジャンプなので、
// 通常の 0.35s スライドアップだと検索だけが遅れて隠れて見える。
// is-instant で transition を切ってから閉じ、強制リフローを挟んで元に戻す
// （＝検索アイコンからの通常トグルは 0.35s のモーションのまま）。
const closeSearchInstant = () => {
	if ( ! searchModal ) return;
	searchModal.classList.add( 'is-instant' );
	closeSearch();
	void searchModal.offsetHeight;
	searchModal.classList.remove( 'is-instant' );
};

const toggleSearch = () => {
	if ( searchModal && searchModal.classList.contains( 'is-open' ) ) {
		closeSearch();
	} else {
		openSearch();
	}
};

// スクロールを止めないため、トップページでヘッダーが隠れる（scrollY<=閾値）と
// top:70px 固定の検索ドロップダウンが宙に浮く。トップ復帰時に検索を閉じる。
if ( homeHeader && homeMv ) {
	window.addEventListener( 'scroll', () => {
		if ( window.scrollY <= TOP_SCROLL_THRESHOLD ) closeSearch();
	}, { passive: true } );
}

// --- クリック / タップでの開閉トリガー ---
document.addEventListener( 'click', ( e ) => {
	const trigger = e.target.closest( '[data-action]' );
	if ( ! trigger ) return;

	switch ( trigger.dataset.action ) {
		case 'drawer-toggle':
			toggleDrawer();
			break;
		case 'drawer-open':
			openDrawer();
			break;
		case 'drawer-close':
			closeDrawer();
			break;
		case 'search-toggle':
			toggleSearch();
			break;
	}
} );

// --- ESC キーで閉じる ---
document.addEventListener( 'keydown', ( e ) => {
	if ( e.key !== 'Escape' ) return;
	closeDrawer();
	closeSearch();
} );

// =============================================================
// ドロワー: 上スワイプで閉じる（参考: swipe-to-close-menu.html）
//
// - スクロール領域の上端（scrollTop <= 0）でのみドラッグ発動
// - フォーム要素（input / button / a / textarea / select）はドラッグ対象外
// - 上方向のドラッグだけ transform に反映（下方向は固定）
// - リリース時、移動量が高さの 25% 以上、または 速度 0.4px/ms 以上で閉じ確定
// =============================================================
if ( drawer ) {
	const drawerContent = drawer.querySelector( '.o-globalDrawer__content' );

	let isDragging = false;
	let startY = 0;
	let currentDelta = 0;
	let drawerHeight = 0;
	let lastY = 0;
	let lastTime = 0;
	let velocity = 0;

	const shouldStartDrag = ( target ) => {
		if ( ! drawerContent ) return true;
		// スクロール領域の上端にいる場合のみドラッグ発動（中身スクロールを邪魔しない）
		return drawerContent.scrollTop <= 0;
	};

	const onPointerDown = ( e ) => {
		if ( ! drawer.classList.contains( 'is-open' ) ) return;
		if ( ! shouldStartDrag( e.target ) ) return;
		// フォーム要素はドラッグ発動させない
		if ( e.target.closest( 'input, button, a, textarea, select' ) ) return;

		isDragging = true;
		startY = lastY = e.clientY;
		lastTime = Date.now();
		drawerHeight = drawer.offsetHeight;
		drawer.classList.add( 'is-dragging' );
		drawer.setPointerCapture && drawer.setPointerCapture( e.pointerId );
	};

	const onPointerMove = ( e ) => {
		if ( ! isDragging ) return;
		const delta = e.clientY - startY;
		// 上方向のドラッグだけ反映（下は固定）
		currentDelta = Math.min( 0, delta );
		drawer.style.transform = `translateY(${ currentDelta }px)`;

		const now = Date.now();
		const dt = now - lastTime;
		if ( dt > 0 ) {
			velocity = ( e.clientY - lastY ) / dt;
		}
		lastY = e.clientY;
		lastTime = now;
	};

	const onPointerUp = () => {
		if ( ! isDragging ) return;
		isDragging = false;
		drawer.classList.remove( 'is-dragging' );

		const distanceThreshold = -drawerHeight * 0.25; // 高さの 25% 以上
		const velocityThreshold = -0.4;                  // 上向き 0.4 px/ms 以上

		if ( currentDelta < distanceThreshold || velocity < velocityThreshold ) {
			closeDrawer();
		} else {
			drawer.style.transform = '';
		}
		currentDelta = 0;
		velocity = 0;
	};

	drawer.addEventListener( 'pointerdown', onPointerDown );
	drawer.addEventListener( 'pointermove', onPointerMove );
	drawer.addEventListener( 'pointerup', onPointerUp );
	drawer.addEventListener( 'pointercancel', onPointerUp );
}

// =============================================================
// Contact Form 7: 送信成功後のリダイレクト (legacy fallback)
//
// 現運用は Contact Form 7 Multi-Step Forms プラグインの [multistep ... "/contact/thanks"] が
// サンクスページ遷移を担うため、このハンドラは hidden field を入れていない通常フォームでは noop。
// フォーム HTML 内に `<input type="hidden" name="_redirect_to" value="...">` を入れた
// フォームに限り、wpcf7mailsent で _redirect_to の URL へ遷移する。
// =============================================================
document.addEventListener( 'wpcf7mailsent', ( event ) => {
	if ( ! event.detail || ! Array.isArray( event.detail.inputs ) ) return;
	const target = event.detail.inputs.find( ( i ) => i.name === '_redirect_to' );
	if ( ! target || ! target.value ) return;

	const form = event.target;
	if ( form && form.style ) {
		form.style.visibility = 'hidden';
	}
	window.location.replace( target.value );
}, false );

// =============================================================
// Contact Form 7: バリデーションエラー文言の位置を正規化
//
// CF7 はバリデーション失敗時、対象フィールドの wpcf7-form-control-wrap 内に
// `<span class="wpcf7-not-valid-tip">` を挿入する。複合フィールド (ラジオ + 補足 input を
// 1 つの c-formField に持つお問い合わせの種類 / 法人・団体等) では、CF7 がラジオと input
// それぞれに tip を挿入してしまい、ラジオと input の間にエラー文言が出てしまう。
//
// Figma 仕様はエラー文言を input の下に 1 件だけ表示。これに合わせるため、
// 各 .c-formField 内の wpcf7-not-valid-tip を末尾 (= input の下) に集約し、
// 同テキストが複数あれば重複を除去する。
//
// 注意: CF7 6.x は change でリアルタイム再検証し、tip を wrap 内だけ削除→再挿入する。
// tip を wrap 外（c-formField 末尾）へ移動すると CF7 が古い tip を掃除できず、
// 再検証のたびに重複・残留する。これを防ぐため
//   - change（リアルタイム再検証）にも追従して正規化を再実行する
//   - フィールドが有効化された（.wpcf7-not-valid が無い）ら残留 tip を全削除する
// =============================================================
const fhpsNormalizeWpcf7ValidationTips = ( form ) => {
	if ( ! form || ! form.querySelectorAll ) return;
	form.querySelectorAll( '.c-formField' ).forEach( ( field ) => {
		const tips = field.querySelectorAll( '.wpcf7-not-valid-tip' );
		if ( tips.length === 0 ) return;

		// フィールドが有効化されている（無効コントロールが無い）なら残留 tip を全削除
		if ( ! field.querySelector( '.wpcf7-not-valid' ) ) {
			tips.forEach( ( tip ) => tip.remove() );
			return;
		}

		// 無効: 同テキストの重複を除去し、1 件だけ末尾（= input の下）へ集約
		const seen = new Set();
		tips.forEach( ( tip ) => {
			const text = ( tip.textContent || '' ).trim();
			if ( seen.has( text ) ) {
				tip.remove();
				return;
			}
			seen.add( text );
			field.appendChild( tip );
		} );
	} );
};

const fhpsScheduleTipNormalize = ( form ) =>
	requestAnimationFrame( () => fhpsNormalizeWpcf7ValidationTips( form ) );

document.addEventListener( 'wpcf7submit', ( event ) => fhpsScheduleTipNormalize( event.target ), false );
document.addEventListener( 'wpcf7invalid', ( event ) => fhpsScheduleTipNormalize( event.target ), false );

// CF7 6.x は change でリアルタイム再検証する。これに追従して重複・残留を防ぐ。
document.querySelectorAll( '.wpcf7-form' ).forEach( ( form ) => {
	form.addEventListener( 'change', () => fhpsScheduleTipNormalize( form ) );
} );

// =============================================================
// Contact Form 7: お問い合わせページ表示時にフォームをクリア
//
// 送信成功時は CF7 が mail_sent で reset し /contact/thanks へ遷移するが、
// ブラウザバック等の bfcache 復元では前回の入力値が残ることがある。
// pageshow（通常表示・bfcache 復元の両方で発火）でフォームを reset し、
// お問い合わせページにアクセスした時は常に空の状態にする。
// =============================================================
window.addEventListener( 'pageshow', () => {
	document.querySelectorAll( '.wpcf7-form' ).forEach( ( form ) => form.reset() );
} );

// =============================================================
// ページトップボタン (.o-globalPageTop)
// scrollY > TOP_SCROLL_THRESHOLD で .is-visible を付け外し → CSS の opacity transition でフェードイン/アウト
// （トップのヘッダー出現と同じ閾値。TOP_SCROLL_THRESHOLD を共用）
// クリックで window.scrollTo(0, 0) (jump、smooth スクロールなし)
// =============================================================
const pageTopBtn = document.querySelector( '.o-globalPageTop' );
if ( pageTopBtn ) {
	const togglePageTopVisibility = () => {
		if ( window.scrollY > TOP_SCROLL_THRESHOLD ) {
			pageTopBtn.classList.add( 'is-visible' );
		} else {
			pageTopBtn.classList.remove( 'is-visible' );
		}
	};
	togglePageTopVisibility();
	window.addEventListener( 'scroll', togglePageTopVisibility, { passive: true } );

	pageTopBtn.addEventListener( 'click', () => {
		closeSearchInstant();
		window.scrollTo( 0, 0 );
	} );
}

// =============================================================
// アーカイブ（年別）アコーディオン (.o-archiveNav)
// お知らせの一覧 / 年別 / 記事詳細で使う。
// 開閉するのは 1169px 以下だけで、それより広い幅は CSS 側で常時展開のサイドバーになる。
// PC では開閉が無いので aria-expanded を外し、支援技術に開閉可能だと伝えない。
// リストの表示切替と ＋/− の差し替えは CSS の [aria-expanded="true"] 側で行う。
// =============================================================
const archiveToggle = document.querySelector( '.o-archiveNav__toggle' );
if ( archiveToggle ) {
	const archiveMq = window.matchMedia( '(max-width: 1169px)' );

	const syncArchiveNav = () => {
		if ( archiveMq.matches ) {
			if ( ! archiveToggle.hasAttribute( 'aria-expanded' ) ) {
				archiveToggle.setAttribute( 'aria-expanded', 'false' );
			}
		} else {
			archiveToggle.removeAttribute( 'aria-expanded' );
		}
	};

	archiveToggle.addEventListener( 'click', () => {
		if ( ! archiveMq.matches ) {
			return;
		}
		const isOpen = archiveToggle.getAttribute( 'aria-expanded' ) === 'true';
		archiveToggle.setAttribute( 'aria-expanded', isOpen ? 'false' : 'true' );
	} );

	syncArchiveNav();
	archiveMq.addEventListener( 'change', syncArchiveNav );
}

// =============================================================
// トップ: 1440 デザインを画面に合わせて縮小する倍率 Z（CSS zoom）
//
// TOP のモーフは図形の箱が固定px（1440 デザインの実寸）なので、狭い/低い画面では
// はみ出す・ヘッダーにかぶる。全体を CSS zoom で縮小して「1440 の絵をそのまま小さく」する。
//
//   Z = min( 1, vw / 1440, vh / 800 )
//
//   - 幅の項: 769〜1439px を 1440 デザインの縮小として見せる
//   - 高さの項: 幅は足りていても縦が短い環境（ノート PC）のかぶりを解消する。
//     幅だけだとデザイン空間の高さは「1440 ÷ アスペクト比」= アスペクト比だけで決まり、
//     1440px 以上では Z が 1 に張り付くため 1px も改善しない。
//     例) 1440×750 のノートは幅の項だと Z=1 のまま。高さの項で Z=0.9375 になり収まる。
//   - 1440×800（デザイン基準 = 参考動画 B_260702.mp4 と同寸）では Z=1 ＝ 現状と完全に同じ
//   - 768px 以下は SP レイアウトなので縮小しない（Z=1 固定）
//
// water-stage.js はこの --fhps-zoom を読み、clip 座標を「デザイン空間（実px ÷ Z）」で組む。
// initWaterStage() より前に評価する必要があるのでこの位置に置く。
// =============================================================
const FHPS_DESIGN_W = 1440;
// 縦の制約は「四角ストップ（Experience）が画面に収まること」で決まる。
// 定数は water-stage.js の anchorSpecs と同値にしておくこと。
const FHPS_SAFE_GAP = 12;    // safeTop のヘッダー下隙間（water-stage.js と同値）
const FHPS_RECT_H   = 673;   // 四角ストップの箱の高さ ＝ img03 の実寸（3 形状で最大）
// 図形の上下に最低これだけ余白を確保する（描画px）。
// 0 だと「はみ出さない最小条件」しか満たさず、下端にぴったり接して切れて見える。
// 1440×800（デザイン基準）で四角が持つ余白は 28.5px なので、それに近い値にしている。
// FHPS_SAFE_GAP 以上にしておくと water-stage.js の safeTop クランプが発動しなくなり、
// 3 形状とも常に「ヘッダー下領域の縦中央」＝上下対称の余白になる。
const FHPS_EDGE_MARGIN = 24;
const FHPS_MIN_ZOOM = 0.3;   // 極端に低いウィンドウで Z が 0 以下になるのを防ぐ下限

// 2026-10-13: CSS zoom を廃止し、rem 調整（_rem.scss）に置き換えた。
//   TOP だけは高さの項も要るので、CSS の html { font-size }（幅だけで決まる）を
//   ここで 16px × Z のインライン指定に上書きする。寸法はすべて r()＝rem なので Z 倍に描画される。
//   --fhps-zoom は water-stage.js が Z を読むために引き続き書く（CSS の zoom には使わない）。
//   下層は CSS の html { font-size } のまま（この関数は TOP 以外ではインラインを外すだけ）。
// 2026-10-21: 下層にも同じ Z を当てるように変更（ユーザー指示・暫定）。
//   TOP だけ高さの項で縮むと、共通パーツ（ヘッダー等）の大きさが TOP と下層でずれるため。
//   縦の短い画面では下層も全体が小さくなる。詳細は claude-logs/2026-10-21_TOPと下層のZをそろえる.md
const FHPS_ROOT_PX = 16;     // _rem.scss の $fhps-root-px と同値

const fhpsIsTop = () =>
	document.body.classList.contains( 'home' ) || document.body.classList.contains( 'front-page' );

const fhpsApplyZoom = () => {
	const root = document.documentElement;
	// 2026-10-21: 幅は innerWidth（スクロールバー込み＝CSS の 100vw と同じ）。
	// <head> の先行計算（functions.php fhps_print_zoom_script）はスクロールバーが出る前に走るため clientWidth が使えない。
	// 両者を同じ値にしないと、theme.js が動いた瞬間に約 1% 縮んで見える。
	const vw = window.innerWidth;
	const vh = window.innerHeight;
	// SP（768px 以下）は CSS の html { font-size } に任せる（2026-10-21 から TOP・下層とも同じ扱い）
	// 判定は CSS の @media と同じ基準（スクロールバー込みの幅）で行う。
	// clientWidth（バー除く）で判定すると、Windows の 769〜785px で CSS は PC・JS は SP 扱いになり縮小されない。
	if ( ! window.matchMedia( '(min-width: 769px)' ).matches ) {
		root.style.removeProperty( 'font-size' );
		root.style.setProperty( '--fhps-zoom', '1' );
		return;
	}
	// ヘッダーも rem で Z 倍に描画されるので、必要なのは「デザイン空間の高さ」（= CSS 上の 70 / 60）。
	// getBoundingClientRect は描画値を返すので、現在適用中の Z で割って戻す。
	//   初回: インライン未適用 → prevZ=1。ただし CSS の html { font-size } が幅の項だけで縮めているため、
	//         描画値は 70 × min(1, vw/1440)。prevZ にはその倍率を使う
	//   リサイズ時: 描画値 70×Z_prev → ÷Z_prev → 70
	const headerEl = document.querySelector( '.o-globalHeader' );
	const prevZ = ( parseFloat( getComputedStyle( root ).fontSize ) || FHPS_ROOT_PX ) / FHPS_ROOT_PX;
	const headerH = headerEl ? headerEl.getBoundingClientRect().height / prevZ : 70;
	// 3 形状は「ヘッダー高を除いた領域の縦中央」に置く（water-stage.js の atMid）。
	// ヘッダーも一緒に縮むので、デザイン空間で
	//   vh/Z >= headerH + EDGE_MARGIN * 2 + RECT_H
	//   -> Z <= vh / ( headerH + EDGE_MARGIN * 2 + RECT_H )
	// headerH / EDGE_MARGIN はデザイン空間の px（描画では ×Z される）。
	//
	// 旧実装の変遷:
	//   1) vh/800 … safeTop も extraTop も勘定に入れておらず、高さの項が効く場面では
	//      ほぼ必ず四角が下にはみ出していた（1200×675 で約 8px）
	//   2) (vh - headerH - 12) / (48 + 673) … はみ出しは直ったが、四角が下端に接したまま
	//      （上 130px / 下 0px の非対称）だった
	//   3) (vh - headerH - 12) / 673 … 四角も中央配置にして 48 が不要に。ただし高さが厳しい環境では
	//      safeTop クランプで上詰め＋下端ぴったりになり、余白 0 で切れて見えた
	//      （1920×1080 の 125% スケーリング = CSS 1536×708 で下の余白 0.9px）
	//   4) 現在: 最低余白 EDGE_MARGIN を制約に入れて、常に上下対称の余白を確保する
	const zFit = vh / ( headerH + FHPS_EDGE_MARGIN * 2 + FHPS_RECT_H );
	// ★ 同じ式を functions.php の fhps_print_zoom_script（<head> で描画前に計算）にも書いている。
	//   式・定数（1440 / 24 / 673 / 0.3 / 16、ヘッダー 70）を変えるときは必ず両方そろえること。
	const z = Math.max( FHPS_MIN_ZOOM, Math.min( 1, vw / FHPS_DESIGN_W, zFit ) );
	root.style.setProperty( '--fhps-zoom', z.toFixed( 4 ) );
	root.style.fontSize = ( FHPS_ROOT_PX * z ).toFixed( 4 ) + 'px';
};

fhpsApplyZoom();
window.addEventListener( 'resize', fhpsApplyZoom );

// =============================================================
// トップページ モーフ演出（img03 を 三角→円→角丸 へ flubber モーフ）
// 実装は water-stage.js。詳細は claude-logs/2026-07-21_TOPモーフアニメーション_*.md
// =============================================================
initWaterStage();

// TOP のみ: 769px をまたいだらリロードする（スマホの回転・折りたたみの開閉・ウィンドウのリサイズ）。
// morph は起動時にしか PC/SP を判定せず、後片付け（destroy）の処理も無い。CSS だけが切り替わると
//   SP → PC: Experience の中身が窓の外に置かれたまま空になる
//   PC → SP: has-water-morph が残り、各セクションの画像が隠れたまま／スライダーは水ステージに移設されたまま
// 理由と検討した代替案は claude-logs/2026-10-16_TOPのPC-SP切替_769px判定とリロード.md
if ( fhpsIsTop() ) {
	window.matchMedia( '(min-width: 769px)' ).addEventListener( 'change', () => location.reload() );
}
